import React from 'react';
import { useParams } from 'react-router-dom';

import { useSuperHubStore } from '@core/store';

import { type SuperHubHashRouteParams } from '@routes/SuperHub/types';

import Tooltip from '@ui/Tooltip';

/**
 * Displays a warning when the user is editing a project setting that is not versioned.
 * @todo Remove this component once glossary and appearance settings are versioned.
 */
export default function UnversionedWarning({
  children,
  isDirty = true,
}: {
  children: React.ReactElement;
  isDirty?: boolean;
}) {
  const versionsTotal = useSuperHubStore(s => s.versions.data.total);

  const { action, section } = useParams<SuperHubHashRouteParams>();
  const unversionedSegmentLabel = section === 'glossary' ? 'Glossary' : action === 'appearance' ? 'Appearance' : null;
  return versionsTotal > 1 && !!unversionedSegmentLabel && isDirty ? (
    <Tooltip asTitle content={`${unversionedSegmentLabel} changes apply to all versions`}>
      {children}
    </Tooltip>
  ) : (
    children
  );
}
